
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import BasePaymentInvoice from './BasePaymentInvoice';

export default function PaymentInvoice() {

    const url = config.url.CONTEXT_URL + "payment-invoice-details?tpslTxnId=all";
    const incompletePath = "/ProfileDetailsWay";
    //     const [showData, setData] = useState([]);
    //     const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    //     let navigate = useNavigate();

    //     function getdata() {
    //         let Url = config.url.CONTEXT_URL + "payment-invoice-details?tpslTxnId=all";
    //         CommonAxiosGet(Url).then((res) => {
    //             if (res?.data?.status === true && res?.data?.scode === "01") {
    //                 setData(res?.data?.data);
    //             }
    //         });
    //     }

    //     useEffect(() => {
    //         getdata();
    //     }, []);

    //     let componentRef = useRef();

    //     const handleprint = useReactToPrint({
    //         content: () => componentRef.current,
    //         documentTitle: "APDSC 2025 Payment-Invoice",
    //         removeAfterPrint: true,
    //         pageStyle: `
    //             @media print {
    //              @page {
    //     margin-top: 20px;
    //     border: 2px solid #6f6666 !important;
    //     padding: 10px;
    //     size: A4 portrait;
    //     margin-bottom: 20px;
    //     margin-left: 20px;
    //     margin-right: 20px;
    //   }
    //                 body {
    //                     -webkit-print-color-adjust: exact;
    //                     print-color-adjust: exact;
    //                 }
    //                 table {
    //                     width: 100% !important;
    //                     table-layout: fixed !important;
    //                     border-collapse: collapse !important;
    //                 }
    //                 th, td {
    //                     padding: 8px !important;
    //                     border: 1px solid #ddd !important;
    //                     word-wrap: break-word;
    //                     max-width: 150px;
    //                 }
    //                 th {
    //                     background-color: #f2f2f2;
    //                 }
    //             }
    //         `
    //     });

    return (
        <BasePaymentInvoice apiUrl={url} incompleteProfilePath={incompletePath} />
        // <React.Fragment>

        //     <div className="heading-main mt-5">
        //         <h3 className="main-title">Payment Invoice</h3>
        //     </div>
        //     <div className="table-responsive" ref={componentRef}>
        //         <div className='print-only-header'>
        //             <Afterprint /></div>
        //         {showData?.length > 0 ? (
        //             <table className="table table-condensed table-bordered table-striped mb-0 mt-3" style={{ borderCollapse: 'collapse' }} role="presentation">
        //                 <thead>
        //                     <tr>
        //                         <th style={{ width: '5%' }}>S.NO</th>
        //                         <th style={{ width: '15%' }}>Candidate Id</th>
        //                         <th style={{ width: '25%' }}>Candidate Name</th>
        //                         <th style={{ width: '15%' }}>Transaction Id</th>
        //                         <th style={{ width: '15%' }}>CFSS Transaction Id</th>
        //                         <th style={{ width: '10%' }}>Paid Amount</th>
        //                         <th style={{ width: '10%' }}>Paid Date</th>
        //                         <th style={{ width: '10%' }}>Payment Status</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>
        //                     {showData.map((item, index) => (
        //                         <tr key={index}>
        //                             <td>{index + 1}</td>
        //                             <td>{item.candidate_id}</td>
        //                             <td>{item.applicant_name}</td>
        //                             <td>{item.tpsl_txn_id}</td>
        //                             <td>{item.cfss_txn_id}</td>
        //                             <td>{item.amount}</td>
        //                             <td>{new Date(item.time_stamp).toLocaleString()}</td>
        //                             <td>{item.status}</td>
        //                         </tr>
        //                     ))}
        //                 </tbody>
        //                 <tfoot>
        //                     <tr>
        //                         <td colSpan={8} className="text-end px-2"><button type='button' className='btn btn-link'>
        //                             <FaDownload title="download invoice" style={{ fontSize: '22px' }} /> Download</button>
        //                         </td>
        //                     </tr>
        //                 </tfoot>
        //             </table>
        //         ) : (
        //             <h3 className="text-error mt-4 border p-3 fs-6 w-100">
        //                 <strong>Dear {loginreducer?.applicant_name},</strong><pre />
        //                 Your Application is Partially Submitted for {CONTEXT_NAME} RECRUITMENT-2025, Please Complete the Application to View Payment History.
        //                 <span>
        //                     <i style={{ background: "#2a9d8f" }}
        //                         className="badge badge-success forgot fw-bold"
        //                         onClick={() => navigate('/ProfileDetailsWay')}
        //                         onKeyDown={(e) => {
        //                             if (e.key === 'Enter' || e.key === ' ') {
        //                                 e.preventDefault();
        //                                 navigate('/ProfileDetailsWay')
        //                             }
        //                         }}
        //                         data-toggle="tooltip" animation="true"
        //                     > Click Here </i>
        //                 </span> to complete the application.
        //             </h3>
        //         )}
        //     </div>
        // </React.Fragment>
    );
}